<!--
 * @Author: RHT
 * @Date: 2022-03-04 09:38:40
 * @LastEditTime: 2022-03-25 18:14:26
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \worke:\poxy\portal\src\views\CloundMonitor\deviceManagement\variableList\index.vue
-->
<template>
  <div class="main">
    <div style="display: flex; align-items: center">
      <!-- <el-button size="mini" type="primary" @click="editParams">添加变量</el-button> -->
      <div style="margin-left: 20px">
        <span style="color: #333">{{ $t("lang.varlist.terminalType") }}：</span>
        <el-select
          size="mini"
          v-model="selectType"
          :disabled="this.terminalId.type == 1"
        >
          <el-option value="0" label="Modbus"></el-option>
          <el-option value="1" label="IO Control"></el-option>
        </el-select>
      </div>
      <el-button
        size="mini"
        type="primary"
        style="margin-left: 20px"
        @click="queryData"
        >{{ $t("lang.varlist.Inquire") }}</el-button
      >
      <el-button
        style="margin-left: 20px"
        size="mini"
        type="primary"
        @click="returnPage"
        v-if="terminalId"
        >{{ $t("lang.varlist.ReturnToTerminalList") }}</el-button
      >
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%;"
      :header-cell-style="{ background: '#e4f1ff' }"
      max-height="900"
      @sort-change="sortChange"
    >
      <el-table-column
        :label="$t('lang.variableList.seriableNumber')"
        align="center"
      >
        <template slot-scope="scope">
          <span
            v-if="scope.$index !== 0"
            style="color: #409eff; font-size: 15px"
          >
            {{ scope.$index }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('lang.varlist.varNmae')"
        min-width="120px"
        align="center"
        sortable="custom"
      >
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0">{{
            scope.row.name
          }}</span>
          <el-input
            v-else
            size="mini"
            v-model="searchObj.name"
            :placeholder="$t('lang.varlist.PleaseEnterVariableName')"
            clearable
            @input="(val) => selectFilters(val, scope)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('lang.varlist.terminalName')"
        align="center"
        min-width="140px"
        sortable="custom"
        @sort-change="sortChange"
      >
        <template slot-scope="scope">
          <span v-if="scope.$index != 0">{{ scope.row.dtuName }}</span>
          <el-input
            v-else
            size="mini"
            v-model="searchObj.dtuName"
            :placeholder="$t('lang.varlist.aName')"
            clearable
            @input="(val) => selectFilters(val, scope)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('lang.variableList.unit')"
        width="100"
        align="center"
        v-if="selectType == 0"
      >
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0 && scope.row.unit">
            {{ scope.row.unit | unitFormat }}
          </span>
          <span v-else-if="scope.$index !== 0 && !scope.row.unit">-</span>
          <!-- <el-select
            v-else
            placeholder="选择单位"
            v-model="searchObj.unit"
            size="mini"
            clearable
            @change="(val) => selectFilters(val, scope)"
          >
            <el-option
              v-for="item in unitOptions"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select> -->
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('lang.variableList.registerMode')"
        min-width="130px"
        align="center"
        v-if="selectType == 0"
      >
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0">
            {{ registerTypeObj[scope.row.registerType] }}
          </span>
          <el-select
            v-else
            v-model="searchObj.registerType"
            :placeholder="$t('lang.editVar.msg7')"
            size="mini"
            clearable
            @change="(val) => selectFilters(val, scope)"
          >
            <el-option
              v-for="item in registerTypeOptions"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <!-- 从站id -->
      <el-table-column
        :label="$t('lang.terminalList.SlaveID')"
        min-width="100px"
        align="center"
        v-if="selectType == 0"
      >
        <template slot-scope="scope">
          <span
            class="font-style
          "
            v-if="scope.$index !== 0"
            >{{ scope.row.sid }}</span
          >
          <!-- <el-input
            v-else
            size="mini"
            v-model="searchObj.sid"
            :placeholder="$t('lang.terminalList.SlaveID')"
            clearable
            @input="(val) => selectFilters(val, scope)"
          ></el-input> -->
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('lang.variableList.registerAddress')"
        align="center"
        min-width="130px"
        v-if="selectType == 0"
      >
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0">
            {{ computedAddress(scope.row) }}
          </span>
          <el-input
            v-else
            size="mini"
            v-model="searchObj.registerAddress"
            placeholder="0-65535"
            clearable
            @input="(val) => selectFilters(val, scope)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('lang.editVar.readandwrite')"
        align="center"
        v-if="selectType == 1"
      >
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0">
            {{
              scope.row.isAlter == 0
                ? $t("lang.editVar.read")
                : $t("lang.editVar.readandwrite")
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('lang.variableList.dataType')"
        min-width="160px"
        align="center"
        v-if="selectType == 0"
      >
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0">
            {{ dataTypeObj[scope.row.dataType] }}
          </span>
          <el-select
            v-else
            :placeholder="$t('lang.varlist.Selectdatatype')"
            size="mini"
            clearable
            v-model="searchObj.dataType"
            @change="(val) => selectFilters(val, scope)"
          >
            <el-option
              v-for="item in dataTypeOptions"
              :label="item.label"
              :value="item.value"
              :key="item.label"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('lang.variableList.byteOrder')"
        min-width="150px"
        align="center"
        v-if="selectType == 0"
      >
        <template slot-scope="scope">
          <span
            class="font-style"
            v-if="scope.$index !== 0 && scope.row.endian"
          >
            {{ endianObj[scope.row.endian] }}
          </span>
          <span
            class="font-style"
            v-else-if="scope.$index !== 0 && !scope.row.endian"
            >-</span
          >
          <el-select
            v-else
            :placeholder="$t('lang.varlist.Selectendian')"
            v-model="searchObj.endian"
            size="mini"
            clearable
            @change="(val) => selectFilters(val, scope)"
          >
            <el-option
              v-for="item in endianOptions"
              :label="item.label"
              :value="item.value"
              :key="item.label"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('lang.variableList.triggerType')"
        min-width="100px"
        align="center"
      >
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0">
            {{ triggerObj[scope.row.trigger] }}
          </span>
          <el-select
            v-else
            :placeholder="$t('lang.varlist.Choosereporttype')"
            size="mini"
            clearable
            v-model="searchObj.trigger"
            @change="(val) => selectFilters(val, scope)"
          >
            <el-option
              v-for="item in triggerOptions"
              :label="item.label"
              :value="item.value"
              :key="item.label"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('lang.variableList.triggerPeriod')"
        min-width="120px"
        align="center"
        sortable="custom"
      >
        <template slot-scope="scope">
          <span
            class="font-style"
            v-if="scope.$index !== 0 && scope.row.interval"
          >
            {{ scope.row.interval + "秒" }}
          </span>
          <span
            class="font-style"
            v-else-if="scope.$index !== 0 && !scope.row.interval + '秒'"
            >-</span
          >
          <el-input
            v-else
            size="mini"
            v-model="searchObj.interval"
            clearable
            type="number"
            @input="(val) => selectFilters(val, scope)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column
        v-if="selectType == 1"
        :label="$t('lang.collect.IOcontrollertype')"
        prop="ioType"
      >
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0">
            {{ ioTypeObj[scope.row.ioType] }}
          </span>
          <el-select
            v-else
            :placeholder="$t('lang.varlist.controltype')"
            size="mini"
            clearable
            v-model="searchObj.ioType"
            @change="(val) => selectFilters(val, scope)"
          >
            <el-option
              v-for="item in ioTypeOptions"
              :label="item.label"
              :value="item.value"
              :key="item.label"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        v-if="selectType == 1"
        :label="$t('lang.collect.interfacenumber')"
        prop="number"
      >
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0">
            {{ scope.row.ioNumber }}
          </span>
          <el-select
            v-else
            :placeholder="$t('lang.collect.interfacenumber')"
            size="mini"
            clearable
            v-model="searchObj.ioNumber"
            @change="(val) => selectFilters(val, scope)"
          >
            <el-option
              v-for="item in ioNumberOptions"
              :label="item.label"
              :value="item.value"
              :key="item.label"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <!-- 计算因子，暂时隐藏 -->
      <el-table-column
        :label="$t('lang.variableList.calculationFactor')"
        min-width="100px"
        align="center"
        v-if="selectType == 0"
      >
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0">{{
            scope.row.factor
          }}</span>
          <!-- <el-input
            v-else
            size="mini"
            v-model="searchObj.factor"
            clearable
            @change="(val) => selectFilters(val, scope)"
            :placeholder="$t('lang.networkMonitoring.pleaseEnter')"
          ></el-input> -->
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('lang.variableList.decimalPrecision')"
        prop="precision"
        align="center"
        sortable="custom"
        width="120px"
        v-if="selectType == 0"
      >
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0">
            {{ scope.row.precision }}
          </span>
          <el-input
            v-else
            size="mini"
            v-model="searchObj.precision"
            :placeholder="$t('lang.varlist.precision')"
            clearable
            type="number"
            @input="(val) => selectFilters(val, scope)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('lang.Button.operation')"
        fixed="right"
        min-width="120px"
        align="center"
        v-if="selectType != 1"
      >
        <template slot-scope="scope">
          <div v-if="scope.$index !== 0">
            <!-- 修改按钮，暂时隐藏 -->
            <!-- <el-button
              v-if="Permission.indexOf(248) !== -1"
              type="primary"
              icon="el-icon-edit"
              circle
              @click="editParams(scope.row)"
            ></el-button>-->
            <el-tooltip
              effect="light"
              :content="$t('lang.variableList.setThreshold')"
            >
              <el-button
                v-if="Permission.indexOf(248) !== -1"
                type="primary"
                icon="el-icon-s-operation"
                circle
                @click="thresholdTap(scope.row)"
              ></el-button>
            </el-tooltip>
            <!-- 警报，暂时隐藏 -->
            <!-- <el-button
              v-if="Permission.indexOf(250) !== -1"
              type="danger"
              icon="icon-lingdang"
              circle
              @click="setAlarm(scope.row)"
            ></el-button>-->
            <!-- 删除，暂时隐藏 -->
            <!-- <el-button
              v-if="Permission.indexOf(249) !== -1"
              type="danger"
              icon="el-icon-delete"
              circle
              @click="removeParams(scope.row)"
            ></el-button>-->
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-divider></el-divider>
    <pagination
      :total="total"
      :offset="offset"
      :limit="limit"
      @SizeChanges="SizeChanges"
      @CurrentChanges="CurrentChanges"
      class="total"
    ></pagination>
    <params-form ref="paramsForm"></params-form>
    <set-alarm ref="setAlarm"></set-alarm>
    <!-- 设置阈值 -->
    <el-dialog
      :title="$t('lang.variableList.setThreshold')"
      :visible.sync="thresholdDialog"
    >
      <el-form :inline="true" :model="threshold" :rules="rule">
        <el-form-item :label="$t('lang.variableList.minimum')" prop="min">
          <el-input
            size="mini"
            type="number"
            v-model="threshold.min"
            style="transform: translateY(5px); width: 180px"
          >
            <template slot="append" v-if="selectRow.unit != 0">
              {{ unitObj[selectRow.unit] | unitFormat }}
            </template>
          </el-input>
        </el-form-item>
        <el-form-item
          style="margin-left: 20px"
          :label="$t('lang.variableList.maximum')"
          prop="max"
        >
          <el-input
            size="mini"
            type="number"
            v-model="threshold.max"
            style="transform: translateY(5px); width: 180px"
          >
            <template slot="append" v-if="selectRow.unit != 0">
              {{ unitObj[selectRow.unit] | unitFormat }}
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="thresholdDialog = false">
          {{ $t("lang.Button.cancel") }}
        </el-button>
        <el-button type="primary" @click="thresholdConfirm">
          {{ $t("lang.Button.confirm") }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  dataTypeObj,
  registerTypeObj,
  triggerObj,
  endianObj,
  unitObj,
  unitOptions,
  registerTypeOptions,
  dataTypeOptions,
  ioTypeObj,
  endianOptions,
  triggerOptions,
  ioTypeOptions,
  ioNumberOptions,
} from "@/utils/paramsConfig";
import { getPermission } from "@/cookie/cookie";
import { getParams, deleteParams } from "@/api/cloudMonitor/paramsList";
import paramsForm from "@/views/CloundMonitor/components/paramsForm";
import setAlarm from "@/views/CloundMonitor/components/setAlarm";
import { mapGetters } from "vuex";
import {
  setThreshold,
  getVariable,
  getVariableList,
  getThreshold,
  editThreshold,
  monitorThreshold,
} from "@/api/cloudMonitor/variableList";
import pagination from "@/components/pagination";
export default {
  components: {
    paramsForm,
    setAlarm,
    pagination,
  },
  data() {
    return {
      thresholdId: 0,
      selectType: "0",
      dataTypeObj,
      registerTypeObj,
      registerTypeOptions,
      triggerObj,
      ioNumberOptions,
      endianObj,
      ioTypeOptions,
      endianOptions,
      dataTypeOptions,
      ioTypeObj,
      triggerOptions,
      unitObj,
      unitOptions,
      thresholdDialog: false,
      Permission: [],
      tableData: [],
      total: 0,
      offset: 1,
      limit: 10,
      threshold: {
        max: 0,
        min: 0,
      },
      selectRow: {},
      //搜索框对象
      searchObj: {
        name: "",
        dtuName: "",
        mname: "",
        registerType: "",
        registerAddress: "",
        dataType: "",
        endian: "",
        trigger: "",
        interval: "",
        precision: "",
        ioType: "",
        ioNumber: "",
        factor: "",
        unit: "",
      },
      ParamsCondition: false, //true为添加 false为编辑
      rule: {
        max: [
          {
            required: true,
            message: this.$t("lang.varlist.maximumvalue"),
            trigger: "blur",
          },
        ],
        min: [
          {
            required: true,
            message: this.$t("lang.varlist.minimumValue"),
            trigger: "blur",
          },
        ],
      },
      timer: null,
    };
  },
  filters: {
    unitFormat(e) {
      if (e) return e.substring(e.indexOf("(") + 1, e.lastIndexOf(")"));
    },
  },
  mounted() {
    this.Permission = getPermission();
    if (this.terminalId) {
      //跳转
      this.selectType = this.terminalId.type.toString();
      getVariable({
        dtuId: this.terminalId.id,
        type: this.selectType,
      })
        .then((res) => {
          if (res.data.code == 0) {
            if (res.data.data.length != 0) {
              this.tableData = res.data.data;
              this.tableData.unshift({});
            }
          } else {
            this.$message({
              type: "error",
              message: this.$t("lang.terminalList.Requestfailed"),
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: this.$t("lang.terminalList.Requestfailed"),
          });
        });
    } else {
      //菜单进入
      this.queryData();
    }
  },
  watch: {
    selectType() {
      if (this.terminalId.type != 1) this.queryData();
    },
  },
  filters: {
    unitFormat(e) {
      if (unitObj[e]) {
        return unitObj[e];
      } else {
        unitObj[e] = e;
        return unitObj[e];
      }
    },
  },
  methods: {
    computedAddress(row) {
      let prefix = "0";
      let str = "00000";
      let type = row.registerType;
      switch (type) {
        case 1:
          str = "00000";
          prefix = "0";
          break;
        case 2:
          str = "10000";
          prefix = "1";
          break;
        case 3:
          str = "40000";
          prefix = "4";
          break;
        case 4:
          str = "30000";
          prefix = "3";
          break;
        default:
          str = "00000";
          prefix = "0";
      }
      let addrStr = row.registerAddress ? row.registerAddress.toString() : "";
      if (addrStr.length >= 5) {
        return prefix + addrStr;
      } else {
        let l = str.length - addrStr.length;
        return str.slice(0, l) + addrStr;
      }
    },
    //修改
    editParams(row) {
      if (row) {
        this.ParamsCondition = false;
        this.$refs.paramsForm.show(row);
      } else {
        this.ParamsCondition = true;
        this.$refs.paramsForm.show();
      }
    },
    //删除
    removeParams(row) {
      this.$confirm(
        this.$t("lang.varlist.confirm1"),
        this.$t("lang.Button.tips"),
        {
          confirmButtonText: this.$t("lang.Button.confirm"),
          cancelButtonText: this.$t("lang.Button.cancel"),
          type: "warning",
          center: true,
        }
      ).then(() => {
        deleteParams(row.id)
          .then((res) => {
            console.log("aaa");
            if (res.data.code === 0) {
              this.$message.success(this.$t("lang.Button.successDelete"));
              this.offset = 1;
              this.queryData();
            } else if (res.data.code === 48) {
              this.$message.error(this.$t("lang.collect.msg7"));
            } else {
              this.$message.error(this.$t("lang.Confirm.DeleteFailed"));
            }
          })
          .catch(() => {});
      });
    },
    setAlarm(row) {
      this.$refs.setAlarm.show(row);
    },
    thresholdTap(row) {
      if (row.type == 1)
        return this.$message({
          message: this.$t("lang.varlist.variabletype"),
          type: "warning",
        });
      if (row.dataType == 10)
        return this.$message({
          message: this.$t("lang.varlist.variabletype"),
          type: "warning",
        });
      this.selectRow = row;
      getThreshold({
        dtuId: row.dtuId,
        vid: row.id,
      }).then((res) => {
        if (res.data.data) {
          this.threshold.max = res.data.data.thresholdB;
          this.threshold.min = res.data.data.thresholdA;
          this.thresholdId = res.data.data.id;
        } else {
          this.threshold.max = 0;
          this.threshold.min = 0;
          this.thresholdId = 0;
        }
      });
      this.thresholdDialog = true;
    },
    CurrentChanges(val) {
      this.offset = val;
      this.queryData();
    },
    SizeChanges(val) {
      this.limit = val;
      this.queryData();
    },
    queryData(qdata = {}) {
      getVariableList({
        type: this.selectType,
        size: this.limit ? this.limit : 10,
        current: this.offset ? this.offset : 0,
        name: qdata.name ? qdata.name : undefined,
        dtuName: qdata.dtuName ? qdata.dtuName : undefined,
        dataType: qdata.dataType ? qdata.dataType : undefined,
        registerType: qdata.registerType ? qdata.registerType : undefined,
        registerAddress: qdata.registerAddress
          ? qdata.registerAddress
          : undefined,
        endian: qdata.endian ? qdata.endian : undefined,
        trigger: qdata.trigger ? qdata.trigger : undefined,
        interval: qdata.interval ? qdata.interval : undefined,
        precision: qdata.precision ? qdata.precision : undefined,
        ioType: qdata.ioType ? qdata.ioType : undefined,
        ioNumber: qdata.ioNumber ? qdata.ioNumber : undefined,
        sortNum: qdata.sortNum ? qdata.sortNum : undefined,
        unit: qdata.unit ? qdata.unit : undefined,
        factor: qdata.factor ? qdata.factor : undefined,
        sid: qdata.sid ? Number(qdata.sid) : undefined,
      }).then((res) => {
        try {
          if (res.data.data.records.length != 0) {
            this.total = res.data.data.total;
            this.tableData = res.data.data.records;
            this.tableData.unshift({});
          } else {
            this.tableData = [{}];
          }
        } catch (err) {
          console.log(err);
        }
      });
    },
    thresholdConfirm() {
      if (false) {
        this.$message({
          type: "error",
          message: "最大值必须大于最小值",
        });
      } else {
        let data = {
          dtuId: this.selectRow.dtuId,
          vid: this.selectRow.id,
          thresholdA: this.threshold.min.toString(),
          thresholdB: this.threshold.max.toString(),
        };
        if (this.thresholdId == 0) {
          setThreshold(data)
            .then((res) => {
              console.log(res);
              if (res.data.code == 0) {
                this.$message({
                  message: this.$t("lang.terminalList.Successfullyadded"),
                  type: "success",
                });
                monitorThreshold(data)
                  .then((res) => {
                    console.log(res);
                  })
                  .catch((err) => {
                    this.$message({
                      type: "error",
                      message: this.$t("lang.varlist.sendcollection"),
                    });
                  });
                this.thresholdDialog = false;
              } else {
                this.$message({
                  type: "error",
                  message: this.$t("lang.customermanagement.message8") + "!",
                });
              }
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: this.$t("lang.varlist.ActionThresholdFailed"),
              });
            });
        } else {
          editThreshold({
            id: this.thresholdId,
            thresholdA: this.threshold.min.toString(),
            thresholdB: this.threshold.max.toString(),
          })
            .then((res) => {
              if (res.data.code == 0) {
                this.$message({
                  type: "success",
                  message: this.$t("lang.terminalList.Successfullymodified"),
                });
                monitorThreshold(data)
                  .then((res) => {
                    console.log(res);
                  })
                  .catch((err) => {
                    this.$message({
                      type: "error",
                      message: this.$t("lang.varlist.sendcollection"),
                    });
                  });
                this.thresholdDialog = false;
              } else {
                this.$message({
                  type: "error",
                  message: this.$t("lang.terminalList.onCallModifying"),
                });
              }
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: this.$t("lang.terminalList.onCallModifying"),
              });
            });
        }
      }
    },
    returnPage() {
      this.$store.dispatch("setTerminalId", "");
      this.$router.push({
        path: `/cloudMonitor/deviceManagement/terminalList`,
      });
    },
    /**
     * 当点击排序时
     * @param {*} col
     */
    sortChange(col) {
      switch (col.order) {
        case "ascending":
          switch (col.column.label) {
            case this.$t("lang.varlist.varNmae"):
              this.queryData({ sortNum: 1 });
              break;
            case this.$t("lang.varlist.terminalName"):
              this.queryData({ sortNum: 3 });
              break;
            case this.$t("lang.variableList.decimalPrecision"):
              this.queryData({ sortNum: 9 });
              break;
            case this.$t("lang.variableList.triggerPeriod"):
              if (this.selectType == 0) this.queryData({ sortNum: 11 });
              else this.queryData({ sortNum: 5 });
              break;
          }
          break;
        case "descending":
          switch (col.column.label) {
            case this.$t("lang.varlist.varNmae"):
              this.queryData({ sortNum: 2 });
              break;
            case this.$t("lang.varlist.terminalName"):
              this.queryData({ sortNum: 4 });
              break;
            case this.$t("lang.variableList.decimalPrecision"):
              this.queryData({ sortNum: 10 });
              break;
            case this.$t("lang.variableList.triggerPeriod"):
              if (this.selectType == 0) this.queryData({ sortNum: 12 });
              else this.queryData({ sortNum: 6 });
              break;
          }
          break;
        default:
          this.queryData();
          break;
      }
    },
    /**
     * 输入框筛选
     */
    selectFilters(val, scope) {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        switch (scope.column.label) {
          case this.$t("lang.varlist.varNmae"):
            this.queryData({ name: val });
            break;
          case this.$t("lang.varlist.terminalName"):
            this.queryData({ dtuName: val });
            break;
          case this.$t("lang.variableList.dataType"):
            this.queryData({ dataType: val });
            break;
          case this.$t("lang.variableList.registerMode"):
            this.queryData({
              registerType: val,
            });
            break;
          case this.$t("lang.variableList.registerAddress"):
            this.queryData({ registerAddress: val });
            break;
          case this.$t("lang.variableList.byteOrder"):
            this.queryData({ endian: val });
            break;
          case this.$t("lang.variableList.triggerType"):
            this.queryData({ trigger: val });
            break;
          case this.$t("lang.variableList.triggerPeriod"):
            this.queryData({ interval: val });
            break;
          case this.$t("lang.variableList.decimalPrecision"):
            this.queryData({ precision: val });
            break;
          case this.$t("lang.collect.IOcontrollertype"):
            this.queryData({ ioType: val });
            break;
          case this.$t("lang.collect.interfacenumber"):
            this.queryData({ ioNumber: val });
            break;
          case this.$t("lang.variableList.unit"):
            this.queryData({ unit: val });
            break;
          case this.$t("lang.variableList.calculationFactor"):
            this.queryData({ factor: val });
            break;
          case this.$t('lang.terminalList.SlaveID'):
            this.queryData({ sid: val });
            break;
        }
      }, 1000);
    },
  },
  computed: {
    ...mapGetters(["terminalId"]),
  },
};
</script>

<style scoped>
.main {
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>
